import ModelCollection from './ModelCollection'
import Job from './Job'

class JobCollection extends ModelCollection {
    filters (filters) {
        let collection = new this.constructor(this.items)

        Object.keys(filters).forEach((filter) => {
            filters[filter].forEach((value) => {
                collection = collection.filterBy(filter, value)
            })
        })

        return collection
    }

    filterBy (filter, value) {
        let filters = {
            'labels': 'filterByLabel',
            'users': 'filterByUser'
        }

        return this[filters[filter]](value)
    }

    filterByLabel (labelId) {
        let items = this.items.filter((item) => {
            return item.labels.find(label => label.id === labelId) !== undefined
        })

        return new this.constructor(items)
    }

    filterByUser (userId) {
        let items = this.items.filter((item) => {
            return item.members.find(member => member.user_id === userId) !== undefined
        })

        return new this.constructor(items)
    }
}

JobCollection.prototype.model = Job

export default JobCollection
